(() => {
  const root = document.getElementById('vod-analytics-privacy');
  if (!root) return;
  const controls = root.querySelector('[data-vod-privacy-controls]');
  const status = root.querySelector('[data-vod-privacy-status]');
  const buttons = [...root.querySelectorAll('[data-vod-analytics]')];
  const connect = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.setTrackingConsent) return;
    controls.hidden = false;
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => { item.disabled = true; });
      const finish = (result) => {
        status.textContent = result?.error ? status.dataset.error : status.dataset.saved;
        buttons.forEach((item) => { item.disabled = false; });
      };
      try { privacy.setTrackingConsent({ analytics: button.dataset.vodAnalytics === 'allow' }, finish); }
      catch { finish({ error: true }); }
    }));
  };
  if (window.Shopify?.customerPrivacy) connect();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) connect();
  });
})();
